import { render } from "./CheckoutChangeTheirLife.vue?vue&type=template&id=54c683ea&scoped=true"
import script from "./CheckoutChangeTheirLife.vue?vue&type=script&lang=js"
export * from "./CheckoutChangeTheirLife.vue?vue&type=script&lang=js"

import "./CheckoutChangeTheirLife.vue?vue&type=style&index=0&id=54c683ea&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c683ea"]])

export default __exports__